import type { GenerationOptions, GenerationResponse } from './types';

export const generateImage2ImageGPTImage1 = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    inputImage: options.inputFiles?.[0],
    inputImages: options.inputFiles,
    aiProvider: 'openai',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'gpt-image-1',
    generationType: 'image'
  });
};

export const generateImage2ImageDALLE3 = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    inputImage: options.inputFiles?.[0],
    inputImages: options.inputFiles,
    aiProvider: 'openai',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'dall-e-3',
    generationType: 'image'
  });
};

export const generateImage2ImageDALLE2 = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    inputImage: options.inputFiles?.[0],
    inputImages: options.inputFiles,
    aiProvider: 'openai',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'dall-e-2',
    generationType: 'image'
  });
};

export const generateImage2ImageGeminiProVision = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    inputImage: options.inputFiles?.[0],
    inputImages: options.inputFiles,
    aiProvider: 'gemini',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'gemini-pro-vision',
    generationType: 'image'
  });
};

export const generateImage2ImageGemini25Pro = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    inputImage: options.inputFiles?.[0],
    inputImages: options.inputFiles,
    aiProvider: 'gemini',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'gemini-2.5-pro',
    generationType: 'image'
  });
};

export const generateImage2ImageGemini25Flash = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    inputImage: options.inputFiles?.[0],
    inputImages: options.inputFiles,
    aiProvider: 'gemini',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'gemini-2.5-flash',
    generationType: 'image'
  });
};

export const generateImage2ImageGemini25FlashImage = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    inputImage: options.inputFiles?.[0],
    inputImages: options.inputFiles,
    aiProvider: 'gemini',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'gemini-2.5-flash-image-preview',
    generationType: 'image'
  });
};

export const generateImage2ImageNanoBanana = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    inputImage: options.inputFiles?.[0],
    inputImages: options.inputFiles,
    aiProvider: 'fal_ai',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'fal-ai/nano-banana/edit',
    generationType: 'image'
  });
};

export const generateImage2ImageFastSDXL = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    inputImage: options.inputFiles?.[0],
    inputImages: options.inputFiles,
    aiProvider: 'fal_ai',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'fast-sdxl',
    generationType: 'image'
  });
};

export const generateImage2ImageFluxSchnell = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    inputImage: options.inputFiles?.[0],
    inputImages: options.inputFiles,
    aiProvider: 'fal_ai',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'flux-schnell',
    generationType: 'image'
  });
};

export const generateImage2ImageFluxDev = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    inputImage: options.inputFiles?.[0],
    inputImages: options.inputFiles,
    aiProvider: 'fal_ai',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'flux-dev',
    generationType: 'image'
  });
};

export const generateImage2ImageSeedReal4 = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    inputImage: options.inputFiles?.[0],
    inputImages: options.inputFiles,
    aiProvider: 'byteplus',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'seedreal-4.0',
    generationType: 'image',
    // Forward multi-image/variation options
    generation_mode: options.generation_mode,
    sequential_image_generation: options.sequential_image_generation,
    sequential_image_generation_options: options.sequential_image_generation_options,
    // Helpful metadata for downstream processing
    purposeMetadata: options.purposeMetadata,
    seed: options.seed,
    variationStrength: options.variationStrength,
  });
};